import { render, staticRenderFns } from "./redBook.vue?vue&type=template&id=4c6b01bf&scoped=true"
import script from "./redBook.vue?vue&type=script&lang=js"
export * from "./redBook.vue?vue&type=script&lang=js"
import style0 from "./redBook.vue?vue&type=style&index=0&id=4c6b01bf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6b01bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c6b01bf')) {
      api.createRecord('4c6b01bf', component.options)
    } else {
      api.reload('4c6b01bf', component.options)
    }
    module.hot.accept("./redBook.vue?vue&type=template&id=4c6b01bf&scoped=true", function () {
      api.rerender('4c6b01bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/redBook/redBook.vue"
export default component.exports